/**
 * Returns a promise that resolves after the specified delay, with the
 * optionally specified value.
 */ export var delay = function(durationMillis, value) {
    return new Promise(function(resolve) {
        setTimeout(function() {
            return resolve(value);
        }, durationMillis);
    });
};
